module.exports = __webpack_public_path__ + "static/CSU-8e9183329d70925ac3275075eb43f6bb.jpg";